import { CheckIcon, LucideIcon, NotebookPenIcon, XIcon } from 'lucide-react'

import { AssessmentDecision } from '@/gen/inventory/v1/assessment_decision_pb'

export type AssessmentDecisionIconProps = {
  decision: AssessmentDecision
}

export const AssessmentDecisionIcon = ({ decision }: AssessmentDecisionIconProps) => {
  const Icon = assessmentDecisionToIcon[decision]
  if (!Icon) return null

  return <Icon className='w-3.75' />
}

const assessmentDecisionToIcon: Record<AssessmentDecision, LucideIcon | null> = {
  [AssessmentDecision.APPROVED]: CheckIcon,
  [AssessmentDecision.CONDITIONALLY_APPROVED]: NotebookPenIcon,
  [AssessmentDecision.REJECTED]: XIcon,
  [AssessmentDecision.UNSPECIFIED]: null,
}
